/* eslint-disable react/jsx-no-bind */
import React, {forwardRef, useEffect, useState} from "react";
import PropTypes from "prop-types";

const CustomModal = forwardRef(({children, handleCloseModal, modalClassName, modalBodyId, show}, ref) => {
  const [
    shouldRender,
    setShouldRender
  ] = useState(show);
  const [
    animationClass,
    setAnimationClass
  ] = useState("animate-in");

  useEffect(() => {
    if (shouldRender) {
      setAnimationClass("animate-in");
    } else {
      setAnimationClass("animate-out");
    }
  }, [shouldRender]);


  const handleClose = () => {
    setShouldRender(false);
  };

  const handleAnimationEnd = () => {
    if (!shouldRender) {
      handleCloseModal();
    }
  };

  return (
    <div className={modalClassName}>
      <div
        className="custom-modal-backdrop"
        onClick={handleClose}
      />
      <div
        className={`custom-modal custom-modal-${animationClass}`}
        onAnimationEnd={handleAnimationEnd}
      >
        <div
          className="custom-modal-close-button"
          onClick={handleClose}
        />
        <div
          className="custom-modal-body"
          id={modalBodyId}
          ref={ref}
        >
          {children}
        </div>
      </div>
    </div>

  );
});

CustomModal.propTypes = {
  "children": PropTypes.node.isRequired,
  "handleCloseModal": PropTypes.func.isRequired,
  "modalBodyId": PropTypes.string,
  "modalClassName": PropTypes.string,
  "show": PropTypes.bool.isRequired
};

CustomModal.defaultProps = {
  "modalBodyId": "CustomModal",
  "modalClassName": "custom-modal-container"
};

export default CustomModal;
